import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import type {Model, Msg} from './architecture.js';
import {main} from './architecture.js';

import {customElement} from 'lit/decorators.js';
import styles from './style.scss';
import {property} from 'lit-element';
import type {AudienceExport} from '#lit/types/audience_exports.js';

export const AUDIENCE_EXPORT_ACTIONS_ELEMENT_TAG = 'audience-export-actions';

/**
 * AudienceExportActions -- All actions available for each row in audience exports table
 */
@customElement(AUDIENCE_EXPORT_ACTIONS_ELEMENT_TAG)
export default class AudienceExportActions extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  @property({type: Object, attribute: 'audience-export'})
  audienceExport!: AudienceExport;

  @property({type: Object})
  frequencies: Record<string, string> = {};

  @property({type: String})
  label = 'Manage';

  @property({type: String, attribute: 'destination-name'})
  destinationName!: string;

  @property({type: String, attribute: 'destination-icon'})
  destinationIcon!: string;

  @property({type: String, attribute: 'destination-path'})
  destinationPath!: string;

  @property({type: String, attribute: 'destination-platform-type'})
  destinationPlatformType?: string;

  @property({type: Boolean, attribute: 'destination-needs-reauthentication'})
  destinationNeedsReauthentication = false;

  @property({type: Boolean, attribute: 'is-expired'})
  isExpired = false;

  @property({type: Boolean, attribute: 'manage-enabled'})
  manageEnabled = false;

  static get styles() {
    return [styles];
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [AUDIENCE_EXPORT_ACTIONS_ELEMENT_TAG]: AudienceExportActions;
  }
}
